import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum SourcifyRequestForPricingLineItemKeys {
  itemSku = 'itemSku',
  Moq = 'Moq',
  FobPrice = 'FobPrice',
  productPackage = 'productPackage',
  sampleCost = 'sampleCost',
  sampleQty = 'sampleQty',
  samplingTime = 'samplingTime',
  toolingCost = 'toolingCost',
  samplingLeadTime = 'samplingLeadTime',
  qty = 'qty',
  size = 'size',
  weight = 'weight',
}

export const sourcifyRequestForPricingFileDataSchema = yup.object().shape({
  RfpNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  buyer: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  sample: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  warehouse: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemSku: yup.string().nullable().optional(),
        Moq: yup.string().nullable().optional(),
        FobPrice: yup.string().nullable().optional(),
        productPackage: yup.string().nullable().optional(),
        sampleCost: yup.string().nullable().optional(),
        sampleQty: yup.string().nullable().optional(),
        samplingTime: yup.string().nullable().optional(),
        toolingCost: yup.string().nullable().optional(),
        samplingLeadTime: yup.string().nullable().optional(),
        qty: yup.string().nullable().optional(),
        size: yup.string().nullable().optional(),
        weight: yup.string().nullable().optional(),
      }),
    )
    .required(),
  instructions: yup.string().nullable().optional(),
})

export type SourcifyRequestForPricingFileData = yup.InferType<
  typeof sourcifyRequestForPricingFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<SourcifyRequestForPricingFileData>

export const SourcifyRequestForPricingFileMappings: RequiredFileData = {
  RfpNumber: 'a3fa0dce-dcdb-4b20-a937-7ce654adad01',
  dateIssued: 'af8c552a-c940-414a-8af4-48d1036d807a',
  dateDue: 'a8c4f8eb-ab2f-4f30-872c-35e1db2582ca',
  paymentTerms: 'dff32c04-5b2c-4732-8b3c-f8f7f82b1168',
  freightTerms: 'a2cfdc35-f488-433a-927f-19e3fe9186f9',
  buyer: {
    attn: 'b22d8ef1-a961-4bb6-9302-8a2b85e6743b',
    companyName: '9ba0342e-dd85-4d1a-b3a6-89b270a909d7',
    addressLine1: '923eff9f-7be5-4783-a2cb-8cfe60451dcb',
    addressLine2: 'b762367b-bb85-4a0d-998a-a423cfe788d4',
    city: '2ac5fee5-4ead-4b09-a255-766267de47f1',
    state: '596d8758-1380-4ee6-958d-eeffee2fb919',
    zipCode: '1156af31-85f1-4583-8dc0-d3f386af6fdd',
    country: 'cf67e1f9-037e-4a07-a4eb-d24ea8c5c18b',
    phoneNumber: '98c5577d-7d0d-4b93-88e2-115c28fe45af',
    emailAddress: '33311f0c-3ab0-4407-8acc-da20340a0e5d',
  },
  sample: {
    attn: '36667821-c2cf-4f0f-b3e1-d58c5d8e4056',
    companyName: 'fcff617e-043c-49f1-988e-feab1b9f554e',
    addressLine1: '27eb875a-bf0f-45d9-938c-c5cbf5c516ca',
    addressLine2: '10630541-74a6-4a0e-ba95-76d8e9d29bd5',
    city: '326b186a-dd1c-4bc9-bcfc-35c72511edde',
    state: '613829ea-785e-40f9-8375-1c8535fcbaec',
    zipCode: '63832953-a93f-4194-9253-6a5da22599c4',
    country: '792aad10-5d19-4365-b6a7-616bfc0c28f5',
    phoneNumber: '4785cc3f-e686-40ca-9007-28d3b71ae85c',
    emailAddress: '1c59950b-22ad-4fd8-8a9c-8ee3a1c6b693',
  },
  warehouse: {
    attn: '9adafb66-1682-4d2d-b0e6-fc73c1388a2d',
    companyName: 'cf491173-14d8-49a3-b9b8-fab861546e2f',
    addressLine1: 'd880734a-7257-428a-a800-0bf3603f6cd6',
    addressLine2: '139ee3e4-23b9-41a0-97d8-72d4e3de4958',
    city: '5db4ba23-1c69-40f5-aea9-584b91819901',
    state: 'a576d9a5-df4e-4567-82bc-5b04fc3345ee',
    zipCode: '0ac043d7-214b-4f98-991f-0f7a688b1b29',
    country: 'd064278b-a57f-475f-9fd4-c8b8cadd97a3',
    phoneNumber: 'da92e420-ca6a-4cdf-9517-f9c9636686ac',
    emailAddress: 'f8db7241-83a6-40d6-af11-4f232460d9ad',
  },
  items: [
    {
      itemSku: 'b76cae8c-9377-40fc-baed-b480b835694d',
      Moq: '05307d24-bb1a-474e-bc3e-434f940cff68',
      FobPrice: '26052280-2f2f-4582-a7fe-b1d12dd76d07',
      productPackage: '0d3c029d-8a04-4aa6-994f-935d6175d394',
      sampleCost: '9ceffc28-421f-4d0c-988c-247d171f3b54',
      sampleQty: 'a4bc8a5f-bd45-4fef-add6-ff4d8031078f',
      samplingTime: '52b6f7b2-8900-4b14-83e0-b3784d26b3ac',
      toolingCost: 'f6636e12-2b7d-4194-a4e9-64865dfcdadb',
      samplingLeadTime: 'e8f9c2a1-d3b7-4e6f-9d8c-1a2b3c4d5e6f',
      qty: '704f2c0a-57de-42d6-ade2-5455d37fd411',
      size: 'ad78d52a-9a25-498b-9839-50288b15cfcd',
      weight: 'f1e2d3c4-b5a6-4789-8901-2345abcdef67',
    },
  ],
  instructions: '3992676d-e178-407e-8ee4-7c3ab77349f5',
}
